import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Arbostumpo situis rande de la vojo, kaj la preterpasantoj ofte stumblis kontraŭ li.
		</p>

		<p class="mb-3">
			- Ne ĉiuj kune, ne ĉiuj kune! – malkontente knaris la Arbostumpo. 
			– Mi akceptos tiom da personoj, kiom mi povas, kaj ne pli. Mi ja solas, kaj da ili – amasego. 
			Kaj ĉiu sen mi ne povas paŝon fari!
		</p>
		`
	)
}

const itemName = {
	esp: 'La arbostumpo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;